import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { BillingDetails } from "../components/checkout/BillingDetails"
import { PaymentSection } from "../components/checkout/PaymentSection"
import { NotificationRender } from "../components/global/NotificationRender"
import { UserContext } from "../contexts/UserContext"
import { useContext } from "react"
import "./checkout.css"

export function Checkout(){
    const userContextData = useContext(UserContext)
    const { notification } = userContextData

    return (
        <div className="checkout-page mx-auto">

            <Breadcrumbs dynamicPath="Checkout" />

            <h1 className="text-black mb-5">Billing Details</h1>

            <div className="d-flex mt-2 checkout-main lg-row">

                {
                    notification && notification.type === "PLACE_ORDER" &&
                        <NotificationRender notification={notification} />
                }

                <BillingDetails />
                <PaymentSection />

            </div>

        </div>
    )
}